import { MapPin } from "lucide-react";

/**
 * Indicateur de zone géographique affiché au sommet d'une section.
 *
 * Permet au pharmacien de vérifier d'un coup d'œil que les indicateurs
 * affichés correspondent bien à sa pharmacie. Important pour la confiance
 * Cabinet 249 €/mois.
 */
export function LocationIndicator({ location }) {
  if (!location || !location.dept) return null;
  const region = location.region_label || location.region || "France";
  return (
    <div
      className="inline-flex items-center gap-2 text-[12px] tracking-wide text-cabinet-mute-1"
      data-testid="location-indicator"
    >
      <MapPin size={13} strokeWidth={1.7} className="text-cabinet-bordeaux/70" />
      <span>
        Indicateurs pour{" "}
        <span className="text-cabinet-ink font-medium">{region}</span>
        {location.dept && (
          <> · département {location.dept}</>
        )}
      </span>
    </div>
  );
}
